import {PATROL_BEGIN, PATROL_END, WORK_END} from '@/library/modules/time-tracker/time-tracker';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state: TimeTrackerState = {
    lastUpdate: 0,
    currentState: WORK_END,
    currentCircumstance: PATROL_END,
    patrolActive: 0,
    lastEntryStampIntl: null,
    workTime: 0,
    actualWorkTime: null,
    allocatedWorkTime: null,
    workTimes: [],
    breakTime: 0,
    compensatedMinimumBreakTime: 0,
    actualBreakTime: null,
    actualBreakTimestamp: 0,
    allocatedBreakTime: 0,
    breakTimes: [],
    homeOffice: false,
    homeOfficeApp: false,
    popup: false,
    popupReset: 0,
    checkIp: 0,
    startDate: null,
    workStart: null,
    breakNotice: '',
    isAbsent: false,
    locked: false,
    hasProject: false,
    hasContact: false,
    lastProject: 0,
    lastContact: 0,
    lastContactName: '',
    lastProjectWorkTime: 0,
    projects: [],
    popupProjectPrompt: false,
};

let index = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default index;